// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
      	suggestionMobileStyle: 'style2'
    }
}; 

// Override Settings
(function () {  // Add this
	BoostPFS.inject(this);  // Add this

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {  
	};

	// Hide products from the member-only collection in the instant search suggestion box
	var isMemberOnlyInstantProduct = function (data) {
		if (!data) return false;
		var config = boostPFSConfig && boostPFSConfig.general ? boostPFSConfig.general : {};
		if (config.is_customer_logged_in) return false;
		if (!config.member_only_collection_handle && !config.member_only_collection_id) return false;

		var targetHandle = String(config.member_only_collection_handle || '');
		var targetId = config.member_only_collection_id ? String(config.member_only_collection_id) : '';
		var collections = data.collections || data.collections_info || data.collection_ids || data.collection;

		if (collections) {
			var matches = function (collection) {
				if (collection === null || typeof collection === 'undefined') return false;
				if (typeof collection === 'string' || typeof collection === 'number') {
					return String(collection) === targetHandle || (targetId && String(collection) === targetId);
				}
				return String(collection.handle || '') === targetHandle || (targetId && String(collection.id || collection.collection_id || '') === targetId);
			};

			if (Object.prototype.toString.call(collections) === '[object Array]') {
				for (var i = 0; i < collections.length; i++) {
					if (matches(collections[i])) return true;
				}
				return false;
			}

			return matches(collections);
		}

		var memberOnlyIds = (config.member_only_product_ids || []).map(String);
		return memberOnlyIds.length > 0 && typeof data.id !== 'undefined' && memberOnlyIds.indexOf(String(data.id)) !== -1;
	};

	var boostPFSOriginalRenderMenu = SearchInput.prototype._bindAutoCompleteRenderMenu;
	SearchInput.prototype._bindAutoCompleteRenderMenu = function (menuElement, data) {
		if (data && typeof data === 'object') {
			var totalFiltered = 0;

			for (var i = 0; i < data.length; i++) {
				var entry = data[i];
				if (entry && entry.key === 'products' && entry.values && entry.values.length) {
					var visibleProducts = [];
					for (var p = 0; p < entry.values.length; p++) {
						if (isMemberOnlyInstantProduct(entry.values[p])) {
							totalFiltered++;
						} else {
							visibleProducts.push(entry.values[p]);
						}
					}
					entry.values = visibleProducts;
				}
			}

			if (totalFiltered > 0) {
				for (var j = 0; j < data.length; j++) {
					if (data[j] && data[j].key === 'total_product' && typeof data[j].values === 'number') {
						data[j].values = Math.max(0, data[j].values - totalFiltered);
					}
				}
			}
		}

		return boostPFSOriginalRenderMenu.call(this, menuElement, data);
	};

	// BoostPFS.prototype.buildSearchResultHeader = function(data){
	// 	jQ('.boost-pfs-filter-breadcrumb').each(function(index, breadcrumb) {
	// 		var html = jQ(breadcrumb).html();
	// 		html = html.replace(/{{terms}}/, Globals.queryParams.q)
	// 		jQ(breadcrumb).html(html);
	// 		jQ(breadcrumb).removeClass('hidden');
	// 	})	
	// };

	// InstantSearch.prototype.beforeInit = function (id) {
	// 	if (Settings.getSettingValue('search.enableSuggestion')) {

	// 		//Remove theme's instant search
	// 		removeThemeSearchEvent();

	// 		var self = this;
	// 		if (typeof id === 'undefined') {
	// 			jQ('input[name="' + this.searchTermKey + '"]').each(function (i) {
	// 				if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
	// 					var id = 'boost-pfs-search-box-' + i;
	// 					jQ(this).attr('id', id);
	// 					self.buildSearchBox('#' + id)
	// 				}
	// 			});
	// 		} else {
	// 			this.buildSearchBox(id);
	// 		}
	// 		if (this.isMobile()) {
	// 			// Clear cache when going back from another page
	// 			window.onpageshow = function (event) {
	// 				if (event.persisted) {
	// 					window.location.reload();
	// 				}
	// 			};
	// 			// Build Suggestion mobile on top
	// 			if (Settings.getSettingValue('search.suggestionMobileStyle') == 'style1') {
	// 				this.buildSuggestionMobile();
	// 			}
	// 		}
	// 	}
	// };

	// function removeThemeSearchEvent() {
	// 	// Remove all events
	// 	if (jQ('.header__search-bar-wrapper').length > 0) {
	// 		var cloneSearchBar = jQ('.header__search-bar-wrapper:first').clone();
	// 		jQ('.header__search-bar-wrapper').replaceWith(cloneSearchBar);
	// 		jQ('.search-bar__filter').hide();
	// 	}
	// 	// Rebuild some event
	// 	if (jQ('[data-action="toggle-search"]').length > 0) {
	// 		jQ('[data-action="toggle-search"]').on('click', function () {
	// 			jQ('.header__search-bar-wrapper').toggleClass('is-visible');
	// 		})
	// 	}
	// 	if (jQ('[data-action="clear-input"]').length > 0) {
	// 		jQ('[data-action="clear-input"]').on('click', function () {
	// 			jQ('input[name="' + bcsffilter.searchTermKey + '"]').val('');
	// 		})
	// 	}
	// }

})();  // Add this at the end